function createNetworkRoleset(attributes) {
  if (!attributes?.id) {
    return null;
  }

  const {
    id,
    name = null,
    roles = [],
    vlan = null,
    inbound_allow_list: inboundAllowList = null,
    inbound_deny_list: inboundDenyList = null,
    encryption = false
  } = attributes;

  return {
    id,
    name,
    roles,
    vlan,
    inboundAllowList,
    inboundDenyList,
    inboundAllowListString: inboundAllowList?.join(', '),
    inboundDenyListString: inboundDenyList?.join(', '),
    encryption
  };
}

export default createNetworkRoleset;
